/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlPolicyMetrics
 */
export interface ControlPolicyMetrics {
    /**
     * 
     * @type {string}
     * @memberof ControlPolicyMetrics
     */
    industry?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlPolicyMetrics
     */
    number_of_employees?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlPolicyMetrics
     */
    number_of_records?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlPolicyMetrics
     */
    quote_company_revenue?: string;
}

/**
 * Check if a given object implements the ControlPolicyMetrics interface.
 */
export function instanceOfControlPolicyMetrics(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ControlPolicyMetricsFromJSON(json: any): ControlPolicyMetrics {
    return ControlPolicyMetricsFromJSONTyped(json, false);
}

export function ControlPolicyMetricsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlPolicyMetrics {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'industry': !exists(json, 'industry') ? undefined : json['industry'],
        'number_of_employees': !exists(json, 'number_of_employees') ? undefined : json['number_of_employees'],
        'number_of_records': !exists(json, 'number_of_records') ? undefined : json['number_of_records'],
        'quote_company_revenue': !exists(json, 'quote_company_revenue') ? undefined : json['quote_company_revenue'],
    };
}

export function ControlPolicyMetricsToJSON(value?: ControlPolicyMetrics | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'industry': value.industry,
        'number_of_employees': value.number_of_employees,
        'number_of_records': value.number_of_records,
        'quote_company_revenue': value.quote_company_revenue,
    };
}

